<template>
    <div class="p-3">
        <loader v-if="pageLoader"></loader>
        <div class="Appointment-section">
            <div class="row">
                <div class="col-md-7 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-4 text-center">
                            <figure><img src="../../../../static/website/images/Schedule-amico.svg" /></figure>
                            <h5 v-if="!pageLoader && appointmentList.totalRecords && appointmentList.totalRecords > 0 ">Please see your exsisting appointments <router-link to="/book-appointment" class="btn-link ">click here</router-link></h5>
                            <h5 v-else>oops! You do not have an Appointment yet!</h5>
                            <router-link to="/book-appointment" class="btn btn-link btn-blue">Book Appointment</router-link>
                            <ul class="mt-5 d-flex justify-content-between align-items-center consult-menu">
                                <li class="text-center mr-3 border-radius-5">
                                    <router-link class="py-3" to="/symptom-checker"><img src="../../../../static/website/images/stethoscope.svg" /> <span>Symptom Checker</span></router-link>
                                </li>
                                <li class="text-center mr-3 border-radius-5">
                                    <router-link class="py-3" to="/medical-records"><img src="../../../../static/website/images/microscope.svg" /> <span>View Medical Records</span></router-link>
                                </li>
                                <li class="text-center History border-radius-5">
                                    <router-link class="py-3" to="/consultation-history"><img src="../../../../static/website/images/Consultations.svg" /> <span>Consultation History</span></router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-5 text-center d-flex justify-content-center align-items-center">
                            <div class="text-center">
                                <h3>Ask a questions</h3>
                                <figure><img src="../../../../static/website/images/consult-illustration.svg" /></figure>
                                <p>Sorry you don't have any Conversations!</p>
                                <p>Please select doctor to start</p>
                                <router-link to="/pro-user" class="btn btn-link btn-blue Upgrade mt-2">Upgrade to Pro user</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="questions-section">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="bg-white border-radius-5 p-3">
                        <h2 class="text-center my-4">Related Questions</h2>
                        <form class="form-search position-relative d-flex justify-content-center align-items-center mb-5">
                            <button class="btn button search"><i class="icon icon-search"></i></button>
                            <input type="text" name="text" placeholder="Search Question" />
                        </form>
                        <div class="row no-gutters">
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
    export default {
        name: 'Consultation',
        data() {
            return {
                pageLoader: false,
                pageLimit : 10,
                page : 1
            }
        },
        methods: {
            listing() {
                let input_json = {
                    'globalParams': {
                        "search":"",
                        "listBy":"",
                        "page": this.page, 
                        "perPage": this.pageLimit,
                        "filter":{}
                    },'localParams': { "parameter": this }
                }
                this._runGetAppointmentList(input_json)
            }
        },
        created(){
            this.listing()
            this.pageName('Consultation')
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/website/consultant/consultation.vue